package studio.goodegg.capsule.listen

import androidx.compose.runtime.Immutable
import com.slack.circuit.runtime.CircuitUiState

@Immutable
data class ListenUiState(
    val eventSink: (ListenUiEvent) -> Unit,
) : CircuitUiState
